// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"e7aed6ca9b4c2b277793","883":"13888225ef58a5e52e3a"}[chunkId] + ".js";
};